import {takeEvery} from 'redux-saga/effects'

import {
  GET_EMAIL_SETTINGS,
  UPDATE_EMAIL_SETTING,
} from '../../Actions/EmailSettings/ActionTypes/ApiActionTypes'
import fetchData from '../SagaHelper'

function* emailSettingsSaga() {
  yield takeEvery(GET_EMAIL_SETTINGS, fetchData)
  yield takeEvery(UPDATE_EMAIL_SETTING, fetchData)
}

export default emailSettingsSaga
